import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { CUSTOMER } = useStore();

	const colDefs = [
		{
			headerName: 'Register Date',
			field: 'registerDate',
			minWidth: 150,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
				? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY hh:mm A'): '';
			},
		},
		{
			headerName: 'Full Name',
			field: 'fullName',
			minWidth: 175,
		},
		{
			headerName: 'Mobile No',
			field: 'mobile',
			minWidth: 120,
		},
		{
			headerName: 'Mobile Verified',
			field: 'isPhoneVerified',
			minWidth: 50,
			cellRenderer: (param) => param.data.isPhoneVerified === 1 ? "Yes" : "No"
		},
		{
			headerName: 'State Name',
			field: 'stateName',
			minWidth: 100,
		},
		{
			headerName: 'City Name',
			field: 'cityName',
			minWidth: 100,
		},
		{
			headerName: 'Email ID',
			field: 'email',
			minWidth: 170,
		},


	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={CUSTOMER.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
})

export default ListComponent;